// Default state when the spinner should be displayed, indicates determining the status of questions in the database, whether the player can play the game
export const QUESTION_STATUS_LOADING = "QUESTION_STATUS_LOADING"
